import httpClient, { ApiResponse } from "@/api/httpClient";

export const getAllFeatureConfigs = async (): Promise<ApiResponse<any>> => {
  const response = await httpClient.get(`/feature-config/all`);
  return response.data.payload.results;
}